import { log } from "@/utils/logger";
import { useQuery } from "@tanstack/react-query";
import { useUser } from "@/context/user";
import storage from "@/utils/storage";
import { isDefined } from "@/utils/validations";
import { Member } from "@/types/utils";
import api from "@/config/api";

const useQueryMembers = () => {
    const authenticated = useUser(state => state.authenticated);
    const oid = storage.getItem("oid");
    const enabled = authenticated && isDefined(oid);

    const getMembers = async () => {
        try {
            const data = await api.get<Member[]>(`/organizations/${oid}/members`);
            return data;
        } catch (e) {
            log.error(e, "getBrands");
        }
    };

    return useQuery({ queryKey: ["members", oid], queryFn: getMembers, enabled });
};

export default useQueryMembers;
